// extracted by mini-css-extract-plugin
module.exports = {"rateOptionsWrapper":"vw","rateOptionsRow":"vx","popover":"vy","popoverArrow":"vz"};